import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomAlertComponent } from './custom-alert/custom-alert.component';
import { CustomLoaderComponent } from './custom-loader/custom-loader.component';

@NgModule({
  declarations: [
    CustomAlertComponent,
    CustomLoaderComponent
  ],
  exports: [
    CustomAlertComponent,
    CustomLoaderComponent
  ],
  imports: [
    CommonModule
  ]
})
export class SharedModule { }
